import React from "react";

const Bash_Cron = () => {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Bash Cron</h2>
      <p>Schedule recurring jobs with <code>cron</code>. Edit crontab with <code>crontab -e</code>.</p><pre><code># Run every day at 2am
0 2 * * * /path/to/backup.sh</code></pre>
    </div>
  );
};

export default Bash_Cron;
